import { useMutation, useQueryClient } from '@tanstack/react-query';
import { attachmentApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

/** Daily photos live in temp storage until the daily itself is saved. */
export function useUploadDailyPhoto() {
  return useMutation({
    mutationFn: (file: File) =>
      attachmentApiClient.uploadTempFile('daily', {
        data: file,
        fileName: file.name,
      }),
    meta: { errorContext: 'daily photo upload' },
  });
}

export function useSaveAttachmentComment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, comment }: { id: string; comment: string }) =>
      attachmentApiClient.updateComment(id, { comment }),
    meta: { errorContext: 'attachment comment' },
    onSettled: () => invalidateFor('dailyAttachment.comment', qc),
  });
}
